(() => {
  const init = (section) => {
    if (!section || section.dataset.chakanaReady) return;
    section.dataset.chakanaReady = 'true';
    if (section.dataset.animate === 'false' || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.classList.add('is-visible');
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        section.classList.add('is-visible');
        observer.disconnect();
      }
    }, { threshold: .18 });
    observer.observe(section);
  };
  const initAll = (root = document) => root.querySelectorAll('[data-ama-chakana]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initAll()) : initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
